import { parseDate } from '@internationalized/date';
import { AxiosError } from 'axios';
import useSWRImmutable from 'swr/immutable';

import {
  lenderDisplayNameMap,
  LoanSummaryResponseT,
  WithStatusT,
} from '@consumer-frontend/nc-utils';

import { apiEndpoints } from '../lib';

export const useLoanSummary = (accountId: string, loanNumber?: string) => {
  const {
    data,
    error,
    isLoading,
  } = useSWRImmutable<WithStatusT<LoanSummaryResponseT>, AxiosError>(
    () => (accountId && loanNumber ? apiEndpoints.dashboard.loanSummary(accountId, loanNumber) : null),
  );

  const nextPayment = data?.next_payment;
  const aggregatedScheduledPayment = nextPayment?.aggregated_scheduled_payment;

  return {
    error,
    isLoading,
    loanSummary: data
      ? {
        currentOwner: lenderDisplayNameMap[data.current_owner],
        hasDrawFeeSaver: data.has_draw_fee_saver,
        hasStatementBalanceFeeSaver: data.has_statement_balance_fee_saver,
        isEnrolledInAutopay: data.is_enrolled_in_autopay,
        loanStatus: data.loan_status,
        nextPayment: nextPayment
          ? {
            aggregatedScheduledPayment: aggregatedScheduledPayment
              ? {
                isAutopay: aggregatedScheduledPayment.is_autopay,
                isMultiple: aggregatedScheduledPayment.is_multiple,
                isPending: aggregatedScheduledPayment.is_pending,
                scheduledAmount: aggregatedScheduledPayment.scheduled_amount,
                targetDate: parseDate(aggregatedScheduledPayment.target_date),
              }
              : undefined,
            amountDue: nextPayment.amount_due,
            dueDate: parseDate(nextPayment.due_date),
            originalAmountDue: nextPayment.original_amount_due,
          }
          : undefined,
        pastDueBalance: data.past_due_balance,
      }
      : undefined,
    status: data?.status || error?.status,
  };
};
